import React from 'react';
import boardMembers from '../../cms/board.json';
import pageIntros from '../../cms/page-intros.json';
import MemberGridPage from '../../components/pages/MemberGridPage';

const intro = pageIntros.board || {};

const Board = () => {
  return (
    <MemberGridPage
      members={boardMembers}
      title={intro.title || 'Our Board Members'}
      subtitle={intro.subtitle || 'Meet the volunteer leaders who guide Hopkins Hillel'}
      introText={
        intro.intro ||
        "Our Governing Board brings together alumni, parents, and community leaders who help steward Hopkins Hillel's mission. Click on any member to learn more about their background."
      }
      baseRoute="/board"
      paramName="boardId"
    />
  );
};

export default Board;
